import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from 'src/app/notification.service';
import { DatePipe } from '@angular/common';
import { TblUser } from 'src/app/shared/models/user';
import { UserServices } from 'src/app/shared/services/userservices';
import { ConfirmDialogComponent } from 'src/app/shared/dialogs/confirm-dialog/confirm-dialog.component';
import { TblLeadSources } from 'src/app/shared/models/leadsources';
import { LeadSourceService } from 'src/app/shared/services/leadsource.services';
import { LocalStorageService } from 'src/app/utility/localStorageService';
import { EditUserDialogComponent } from './edit-user-dialog.component';
import { PagerService } from 'src/app/shared/pagination';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  @ViewChild('dt1') dt1: any; 
  isEditing:boolean;
  model: TblUser;
  users: Observable<TblUser[]>;
  allItems: TblUser[] = [];
  pagedItems: TblUser[] = [];
  pager: any = {};
  modalRef: BsModalRef;
  editDataAvbl: boolean;
  boxTitle: string;
  edit: any;
  startDate:any
  leadSources: Observable<TblLeadSources[]>;
  userType: string;
  
  constructor(private _userservices : UserServices,
    private modalService: BsModalService,
    private spinnerService: AppComponent ,
    private localStorage:LocalStorageService,
    private _leadSourceService : LeadSourceService,
    private notifyService : NotificationService,
    private dialog: MatDialog,
    private pagerService: PagerService) {
  }

  ngOnInit(): void {
    this.userType = this.localStorage.get("userType")
    this.model=new TblUser();
    this.getAllData();
    this.startDate=new Date()
    this.getAllLeadSources();
  }
  ngAfterViewInit() {
    //this.dt1.datetimeFormat = {"yyyy-mm-dd"};
  }
  getAllLeadSources()
  {
    this.leadSources= this._leadSourceService.getAllLeadSource();
  }
  getAllData(){
    //this.spinnerService.spinnerStatus(true);
    this.users= this._userservices.getAllUsers();
    this.users.subscribe(data => {
      this.allItems = data || [];
      this.setPage(1);
    });
    //this.spinnerService.spinnerStatus(false);
  }
  
  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.allItems.length, page, 8);
    this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  
  openAddDialog() {
    const model = new TblUser();
    const dialogRef = this.dialog.open(EditUserDialogComponent, {
      width: '500px',
      data: {
        title: 'Add New User',
        model: model,
        leadSources: this.leadSources,
        isEditing: false
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.action === 'save') {
        this.model = result.model;
        this.edit = false;
        this.create_edit();
      }
    });
  }

  openEditDialog(id: any) {
    this._userservices.getUserByUserId(id).subscribe(
      resp => {
        const dialogRef = this.dialog.open(EditUserDialogComponent, {
          width: '500px',
          data: {
            title: 'Edit User',
            model: resp,
            leadSources: this.leadSources,
            isEditing: true
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result && result.action === 'save') {
            this.model = result.model;
            this.edit = true;
            this.create_edit();
          }
        });
      },
      (error: HttpErrorResponse) => {
        this.notifyService.showError('Error loading user data', 'Error');
      }
    );
  }


  //Editing Data
  validateForm():boolean{
    // if(!this.model.name){
    //   this.notifyService.showError("Name can not be empty!", "Error");
    //   return false;
    // }
   // else 
    if(!this.model.emailId){
      this.notifyService.showError("Email ID can not be empty!", "Error");
      return false;
    }
    else {
      return true;
    }
  }
  deleteClick(id:string)
  {
    
    let modalConfig: any = { animated: true, keyboard: true, backdrop: true, ignoreBackdropClick: false };
    const initialState = {mode:'Delete',  module: 'User', refNo:id};
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, modalConfig, { class: 'modal-sm', initialState }))


    
  }
  create_edit(){

    if(!this.validateForm())
      {
      return;
    }
    if(this.edit){
           this._userservices.saveAndUpdate(this.model).subscribe(resp=>{
        if(resp.refNo>0){
          this.notifyService.showSuccess("Updated Successfully!", "Success");
          this.getAllData()
        }
        else{
          this.notifyService.showError(resp.message, "Error")
        }
      });
    }
    else{
      this._userservices.saveAndUpdate(this.model).subscribe(resp=>{
        if(resp.refNo>0){
          this.notifyService.showSuccess("Saved Successfully!", "Success");
          this.getAllData()
        }
        else{
          this.notifyService.showError(resp.message, "Error")
        }
      },(err) => {
        this.notifyService.showError(err, "Error")
      });
    }
  }
  close_clicked()
  {
    this.getAllData();
  }
  stopPropagation(event){
    event.stopPropagation();
    }
  searchTable() {
    var term, table;
    term=document.getElementById("myInput") as unknown as HTMLInputElement
    // get term to search
    term = term.value.toLowerCase();
    table =document.getElementById("myTable") as HTMLTableElement
    // get table rows, handle as array.
    table = Array.from(table.rows);

    // filter non-matching rows; these are set to display='none'
    table.filter(function(el) {
        return el.textContent.toLowerCase().indexOf(term) ==
            -1
    }).map(x => x.style.display = "none");

    // filter matching rows; these are set to display =''
    table.filter(function(el) {
        return el.textContent.toLowerCase().indexOf(term) > -1
    }).map(x => x.style.display = "");
}
}
